import React, { Component } from 'react';
import { Modal, Spin, Tooltip } from 'antd';
import { connect } from 'dva';
import ListPage from '../../../../../../components/ListPage';
import { getAppCode } from '../../../utils/utils';
import './index.less';

const { ListTable } = ListPage;

@connect(({ artcleLists }) => {
  return {
    ...artcleLists,
  };
})

class AdjustOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      columns: [],
      dataSource: [],
      totalElements: '',
      params: {
        title: '',
        appCode: getAppCode(),
        page: 1,
        pageSize: 10,
        channelId: props.channelId,
        newsLabelId: 0,
        newsTypes: '0,1',
      },
    };
  }

  componentDidMount() {
    const { params } = this.state;
    this.fetchPublishList(params);
    this.setColumns()
  }

  handerOption = (direction, data) => {
    const { params } = this.state;
    const { dispatch } = this.props;
    const { id } = data;
    dispatch({
      type: 'artcleLists/fetchNewsMove',
      params: {
        id,
        direction,
        appCode: getAppCode(),
        newsTypes: '0,1'
      },
    })
      .then(() => {
        this.setState({ loading: false });
        this.fetchPublishList(params);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  fetchPublishList = params => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'artcleLists/fetchPublishList',
      params,
    })
      .then(res => {
        this.setState({
          loading: false,
          dataSource: res.content,
          totalElements: res.totalElements,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  setColumns = () => {
    const columns = [
      {
        title: '标题',
        dataIndex: 'title',
        key: 'title',
        render: text => {
          if (text?.length <= 20) {
            return <span>{text}</span>;
          }
          return (
            <Tooltip placement="top" title={text}>
              <span>{text.substring(0, 20)}...</span>
            </Tooltip>
          );
        },
      },
      {
        title: '关联标签',
        dataIndex: 'labelList',
        key: 'labelList',
        // width: 220,
        render: (text, record) => {
          const str = record.labelData && record.labelData.join(';');
          if (!str) {
            return <span>-</span>;
          }
          if (str.length <= 12) {
            return <span>{str}</span>;
          }
          return (
            <Tooltip placement="top" title={str}>
              <span>{str.substring(0, 12)}...</span>
            </Tooltip>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 160,
        fixed: 'right',
        render: (text, record) => {
          return (
            <>
              <a style={{ marginRight: 8 }} onClick={() => this.handerOption('up', record)}>上移</a>
              <a style={{ marginRight: 8 }} onClick={() => this.handerOption('down', record)}>下移</a>
              <a onClick={() => this.handerOption(record.stayonTop === 0 ? 'top' : 'cancelTop', record)}>{record.stayonTop === 0 ? '置顶' : '取消置顶'}</a>
            </>
          )
        },
      },
    ];
    this.setState({ columns });
  };


  changePage = (page, pageSize) => {
    const { params } = this.state;
    const { channelId, } = this.props;
    const tempParams = {
      ...params,
      page,
      pageSize,
      channelId: channelId === '0' ? '' : channelId,
    };
    this.setState({ params: tempParams });
    this.fetchPublishList(tempParams);
  };

  handleCancel = () => {
    const { close, refreshData } = this.props;
    refreshData()
    close()
  };

  render() {
    const { visible } = this.props;
    const { totalElements, columns, dataSource, loading, params } = this.state;
    const { page } = params;

    const tableProps = {
      pageInfo: { totalElements, page },
      columns,
      list: dataSource,
      rowKey: 'id',
      onPageChange: this.changePage,
    };

    return (
      <Modal
        width={800}
        wrapClassName='course-manage-adjust-order-modal-wrap'
        title="调整顺序"
        visible={visible}
        footer={null}
        centered
        onCancel={this.handleCancel}
      >
        <Spin spinning={loading}>  <ListTable {...tableProps} /> </Spin>
      </Modal>
    );
  }
}

export default AdjustOrder;
